
import React from 'react'

const Nophotocouple = ({details}) => {

   const renderPersonCard = ({
    fullname,
    parentprefix,
    parentsName,
    grandParentsPrefix,
    grandParentsName,
  }) => {
    return (
      <div className="t3-single-couple-container">

        <div className="t3-couple-grandparents">
          {grandParentsName && (
  <p>
    {grandParentsPrefix} {grandParentsName}
  </p>
)}
        </div>

        <h1 className="t3-couple-name">
          {fullname}
        </h1>

        <div className="t3-couple-parents">
        {parentsName && (
  <p>
    {parentprefix} {parentsName}
  </p>
)}
        </div>

      </div>
    );
  };

  const groomCard = () =>
    renderPersonCard({
      fullname: details?.groomFullName || "Groom Full Name",
      parentprefix: details?.groomParentsPrefix,
      parentsName: details?.groomParents,
      grandParentsPrefix: details?.groomGrandParentsPrefix,
      grandParentsName: details?.groomGrandParents,
    });

  const brideCard = () =>
    renderPersonCard({
      fullname: details?.brideFullName || "Bride Full Name",
      parentprefix: details?.brideParentsPrefix,
      parentsName: details?.brideParents,
      grandParentsPrefix: details?.brideGrandParentsPrefix,
      grandParentsName: details?.brideGrandParents,
    });



  return (
    <section className="couple-section no-photo-couple theme3">
      <div className="theme-3-couple">
          <div className="theme-3-couple-card">
              <div className="t3-couple-inner-content">
                  <h1 className='t3-couple-heading'>{details?.sectionHeading}</h1>
                      <div className="t3-couple-wrapper">
                   {details?.displayOrder === "groomFirst" ? (
                    <>
                      {groomCard()}
                          <span className="t3-couple-divider">
                        &
                    </span>
                    {brideCard()}
                    </>
                   ) : ( <>
                       {brideCard()}
                         <span className="t3-couple-divider">
                        &
                    </span>
                    {groomCard()}
                   </>) }

                
               </div>
              </div>
            
             
          </div>
      </div>
    </section>
  )
}

export default Nophotocouple